import React, { useState } from 'react';
import { useCesium } from '../../../context/CesiumContext';
import styles from './MapTools.module.scss';

const SelectIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 2v9l3-2.5 2 4 1.5-.7-2-4H11L3 2z" fill="currentColor" />
  </svg>
);

const DrawIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10.5 2.5l3 3-7 7H3.5v-3l7-7z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MeasureIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 10l4-4 3 3 5-5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 13h12" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const LayersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 5.5L8 2l6 3.5-6 3.5-6-3.5z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 9l6 3.5L14 9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const GearIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M11.54 4.46l-1.41 1.41M4.95 11.54l-1.41 1.41" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const TOOLS = [
  { id: 'select', Icon: SelectIcon, title: 'Select' },
  { id: 'draw', Icon: DrawIcon, title: 'Draw' },
  { id: 'measure', Icon: MeasureIcon, title: 'Measure' },
  { id: 'layers', Icon: LayersIcon, title: 'Layers' },
  { id: 'settings', Icon: GearIcon, title: 'Settings' },
];

interface Props {
  onLayersClick?: () => void;
}

const MapToolsBar: React.FC<Props> = ({ onLayersClick }) => {
  const cesium = useCesium();
  const [activeTool, setActiveTool] = useState('select');

  const handleClick = (id: string) => {
    if (id === 'layers' && onLayersClick) onLayersClick();
    if (id === 'measure') {
      cesium.startMeasureMode();
    } else {
      cesium.stopMeasureMode();
    }
    setActiveTool(id);
  };

  return (
    <div className={styles.pill}>
      {TOOLS.map(({ id, Icon, title }) => (
        <button
          key={id}
          className={`${styles.tool} ${activeTool === id ? styles.active : ''}`}
          type="button"
          title={title}
          onClick={() => handleClick(id)}
        >
          <Icon />
        </button>
      ))}
    </div>
  );
};

export default MapToolsBar;
